import { customerApiClient } from './customer-api-client';
import type { NotificationItem, NotificationListResponse } from './notification.service';

/**
 * B6.19 / B6.18 CU-1 — the customer's inbox.
 *
 * B6.16 proved a customer can download a published Service Report; nothing told
 * them one existed. These two calls are how they find out.
 *
 * Scoped entirely server-side from the CUSTOMER JWT — no contact id, customer id
 * or tenant id is ever sent, so there is nothing for a client to tamper with.
 * Uses `customerApiClient`, which carries the customer token domain
 * (`CUSTOMER_JWT_SECRET`, `type: customer_access`) and can never reach a staff
 * endpoint.
 */
export type { NotificationItem };

export const customerNotificationService = {
  list: (limit = 20): Promise<NotificationListResponse> =>
    customerApiClient
      .get<NotificationListResponse>('/customer-portal/notifications', { params: { limit } })
      .then((r) => ({
        items: Array.isArray(r.data?.items) ? r.data.items : [],
        unreadCount: r.data?.unreadCount ?? 0,
      })),

  markRead: (id: string): Promise<void> =>
    customerApiClient
      .patch<void>(`/customer-portal/notifications/${id}/read`)
      .then(() => undefined),
};
